export const INPUT_STAGING_EVENT_DEBOUNCE_MS = 1000;